enum Alignment {
  CENTRE = 'centre',
  JUSTIFIED = 'justified',
}

export default Alignment;
